export const getLoggedInUserRole = () => {
  const storedUser = localStorage.getItem('user');
  if (!storedUser) return null;
  try {
    const { role } = JSON.parse(storedUser);
    return role;
  } catch {
    return null;
  }
};

export const getLoggedInUsername = () => {
  const storedUsername = localStorage.getItem('username');
  return storedUsername || null;
};

/** JWT payload (userId, role, companyId) — for scoping API calls to the logged-in user. */
export const getJwtPayload = () => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
};

export const getUserIdFromToken = () => {
  const payload = getJwtPayload();
  return payload?.userId != null ? String(payload.userId) : null;
};

/** True when the logged-in identity is super_admin (redux/localStorage or JWT). */
export const isSuperAdminRole = (role) => {
  const candidates = [
    role,
    (() => {
      try {
        return JSON.parse(localStorage.getItem('user') || '{}').role;
      } catch {
        return null;
      }
    })(),
    getJwtPayload()?.role,
  ];
  return candidates.some((r) => {
    const n = String(r || '').trim().toLowerCase();
    return n === 'super_admin' || n === 'superadmin';
  });
};

const ROLE_SELF_KEY = {
  admin: 'admin_id',
  super_stokez: 'super_stokez_id',
  stokez: 'stokez_id',
  agent: 'agent_id',
  player: 'player_id',
};

/**
 * Hierarchy IDs that are fixed for the logged-in user (their company, self, and parents).
 * Used to preselect create/report dropdowns when those levels are not shown.
 */
export const buildLockedHierarchySelections = (user) => {
  if (!user || isSuperAdminRole(user.role)) return {};
  const jwt = getJwtPayload() || {};
  const locked = {};
  const companyId = user.companyId || user.company_id || jwt.companyId;
  if (companyId) {
    locked.company_id = String(companyId);
  }

  const selfId = user.userId || user._id || getUserIdFromToken();
  const selfKey = ROLE_SELF_KEY[user.role];
  if (selfKey && selfId) {
    locked[selfKey] = String(selfId);
  }

  ['admin_id', 'super_stokez_id', 'stokez_id', 'agent_id'].forEach((key) => {
    if (user[key]) locked[key] = String(user[key]);
  });

  return locked;
};
